<template>
	<div class="code-otp" id="input">
		<input class="input-code-otp inputs first" placeholder="•"
		       v-on:keyup="nextInputCode" v-on:keydown="prevInputCode"
		       id="partitioned-1" type="tel" minLength="0" maxlength="1"
		       v-model="code_1" autocomplete="off"/>
		<input class="input-code-otp inputs" minLength="0" placeholder="•"
		       v-on:keydown="prevInputCode" v-on:keyup="nextInputCode"
		       id="partitioned-2" type="tel" maxlength="1"
		       v-model="code_2" autocomplete="off"/>
		<input class="input-code-otp inputs" minLength="0" placeholder="•"
		       v-on:keydown="prevInputCode" v-on:keyup="nextInputCode"
		       id="partitioned-3" type="tel" maxlength="1"
		       v-model="code_3" autocomplete="off"/>
		<input class="input-code-otp inputs" minLength="0" placeholder="•"
		       v-on:keydown="prevInputCode" v-on:keyup="nextInputCode"
		       id="partitioned-4" type="tel" maxlength="1"
		       v-model="code_4" autocomplete="off"/>
		<input class="input-code-otp inputs" minLength="0" placeholder="•"
		       v-on:keydown="prevInputCode" v-on:keyup="nextInputCode"
		       id="partitioned-5" type="tel" maxlength="1"
		       v-model="code_5" autocomplete="off"/>
		<input class="input-code-otp inputs" minLength="0" placeholder="•"
		       v-on:keydown="prevInputCode" v-on:keyup="nextInputCode"
		       id="partitioned-6" type="tel" maxlength="1"
		       v-model="code_6" autocomplete="off"/>
	</div>
</template>

<script>
	export default {
		name: "InputOtp",
		props: ["bindButton"],
		data() {
			return {
				code_1: "",
				code_2: "",
				code_3: "",
				code_4: "",
				code_5: "",
				code_6: "",
			}
		},
		methods: {
			nextInputCode(event) {
				var nums = event.target.value;
				var number = nums.replace(/[^0-9]+/, '');
				event.target.value = number;
				if (this.code_1 !== "" &&
					this.code_2 !== "" &&
					this.code_3 !== "" &&
					this.code_4 !== "" &&
					this.code_5 !== "" &&
					this.code_6 !== ""
				) {
					var otp = this.code_1 + this.code_2 + this.code_3 + this.code_4 + this.code_5 + this.code_6
					this.onComplete(otp)
					if (this.bindButton || this.bindButton !== "") {
						return
						$(this.bindButton).prop('disabled', true)
					}
				} else {
					if ((event.target.value.length === event.target.maxLength) && number !== '') {
						$(event.target).next('.inputs').focus();
					}
				}
			},
			prevInputCode(event) {
				if (event.target.value === '') {
					if (event.keyCode === 8) {
						$(event.target).prev('.inputs').focus();
						if (this.bindButton || this.bindButton !== "") {
							return
							$(this.bindButton).prop('disabled', true);
						}
					}
				}
			},
			onComplete(otp) {
				this.$emit("onComplete", otp)
			}
		}
	}
</script>